<template>
  <div class="box">
    <div class="up">
      <div
          class="bg-color-black item1"
          v-for="item in titleItem"
          :key="item.title"
      >
        <p class="ml-3 colorBlue fw-b fs-xl">{{ item.title }}</p>
        <div>
          <dv-digital-flop
              class="dv-dig-flop ml-1 mt-2 pl-3"
              :config="item.number"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {getUserTotal} from "@/api/area/left1";

export default {
  data() {
    return {
      titleItem: [
        {
          title: '总人数',
          number: {
            number: [120],
            toFixed: 0,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26,
              fill: '#3de7c9'
            }
          }
        },
        {
          title: '总检测次数',
          number: {
            number: [7301],
            toFixed: 0,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '本月新增',
          number: {
            number: [2],
            toFixed: 0,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '异常次数',
          number: {
            number: [14],
            toFixed: 0,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26,
              fill: '#FF0000'
            }
          }
        }
      ],
    }
  },
  components: {
    // CenterChart
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      getUserTotal().then((res) => {
        if (res.code === "0") {
          // 总人数
          this.titleItem[0].number.number[0] = res.data.total;
          this.titleItem[0].number = {...this.titleItem[0].number}
          // 总监测次数
          this.titleItem[1].number.number[0] = res.data.test;
          this.titleItem[1].number = {...this.titleItem[1].number}
          // 本月新增
          this.titleItem[2].number.number[0] = res.data.curMonth;
          this.titleItem[2].number = {...this.titleItem[2].number}
          // 异常人次
          this.titleItem[3].number.number[0] = res.data.curMonth;
          this.titleItem[3].number = {...this.titleItem[3].number}
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/box';

.item1 {
  border-radius: 6px;
  padding-top: 8px;
  margin-top: 8px;
  width: 48%;
  height: 70px;

  .dv-dig-flop {
    width: 150px;
    height: 30px;
  }
}

</style>
